exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select-input-new-user {\n  margin-top: auto !important;\n}", ""]);

